<template>
  <main class="bd-main order-1 container">
    <div class="bd-intro ps-lg-4">
      <div
        class="d-md-flex flex-md-row-reverse align-items-center justify-content-between"
      >
        <a
          class="btn btn-sm btn-bd-light mb-2 mb-md-0"
          href="https://github.com/twbs/bootstrap/blob/main/site/content/docs/5.0/content/typography.md"
          title="View and edit this file on GitHub"
          target="_blank"
          rel="noopener"
          >View on GitHub</a
        >
        <h1 class="bd-title" id="content">Typography</h1>
      </div>
      <p class="bd-lead">
        Documentation and examples for Bootstrap typography, including global
        settings, headings, body text, lists, and more.
      </p>
    </div>
    <div class="row">
      <div class="bd-toc mt-4 mb-5 my-md-0 ps-xl-3 mb-lg-5 text-muted col-md-3">
        <strong class="d-block h6 my-2 pb-2 border-bottom">On this page</strong>
        <nav id="TableOfContents">
          <ul>
            
            <li>
              <a href="#headings">Headings</a>
              <ul>
                <li>
                  <a href="#customizing-headings">Customizing headings</a>
                </li>
              </ul>
            </li>
            <li><a href="#display-headings">Display headings</a></li>
            <li><a href="#lead">Lead</a></li>
            <li><a href="#inline-text-elements">Inline text elements</a></li>
            <li><a href="#text-utilities">Text utilities</a></li>
            <li><a href="#abbreviations">Abbreviations</a></li>
            <li>
              <a href="#blockquotes">Blockquotes</a>
              <ul>
                <li><a href="#naming-a-source">Naming a source</a></li>
                <li><a href="#alignment">Alignment</a></li>
              </ul>
            </li>
            <li>
              <a href="#lists">Lists</a>
              <ul>
                <li><a href="#unstyled">Unstyled</a></li>
                <li><a href="#inline">Inline</a></li>
                <li>
                  <a href="#description-list-alignment"
                    >Description list alignment</a
                  >
                </li>
              </ul>
            </li>
            <li><a href="#responsive-font-sizes">Responsive font sizes</a></li>
            <li>
              <a href="#sass">Sass</a>
              <ul>
                <li><a href="#variables">Variables</a></li>
                <li><a href="#mixins">Mixins</a></li>
              </ul>
            </li>
          </ul>
        </nav>
      </div>

      <div class="bd-content ps-lg-4 col-md-9">
        <h2 id="headings">
          Headings<a
            class="anchorjs-link "
            aria-label="Anchor"
            data-anchorjs-icon="#"
            href="#headings"
            style="padding-left: 0.375em;"
          ></a>
        </h2>
        <p>
          All HTML headings, <code>&lt;h1&gt;</code> through
          <code>&lt;h6&gt;</code>, are available.
        </p>
        <table class="table">
          <thead>
            <tr>
              <th>Heading</th>
              <th>Example</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <code>&lt;h1&gt;&lt;/h1&gt;</code>
              </td>
              <td><span class="h1">h1. Bootstrap heading</span></td>
            </tr>
            <tr>
              <td>
                <code>&lt;h2&gt;&lt;/h2&gt;</code>
              </td>
              <td><span class="h2">h2. Bootstrap heading</span></td>
            </tr>
            <tr>
              <td>
                <code>&lt;h3&gt;&lt;/h3&gt;</code>
              </td>
              <td><span class="h3">h3. Bootstrap heading</span></td>
            </tr>
            <tr>
              <td>
                <code>&lt;h4&gt;&lt;/h4&gt;</code>
              </td>
              <td><span class="h4">h4. Bootstrap heading</span></td>
            </tr>
            <tr>
              <td>
                <code>&lt;h5&gt;&lt;/h5&gt;</code>
              </td>
              <td><span class="h5">h5. Bootstrap heading</span></td>
            </tr>
            <tr>
              <td>
                <code>&lt;h6&gt;&lt;/h6&gt;</code>
              </td>
              <td><span class="h6">h6. Bootstrap heading</span></td>
            </tr>
          </tbody>
        </table>
        <div class="bd-clipboard">
          <button
            type="button"
            class="btn-clipboard"
            title=""
            data-bs-original-title="Copy to clipboard"
          >
            Copy
          </button>
        </div>
        <div class="highlight">
          <pre
            class="chroma"
          ><code class="language-html" data-lang="html"><span class="p">&lt;</span><span class="nt">h1</span><span class="p">&gt;</span>h1. Bootstrap heading<span class="p">&lt;/</span><span class="nt">h1</span><span class="p">&gt;</span>
<span class="p">&lt;</span><span class="nt">h2</span><span class="p">&gt;</span>h2. Bootstrap heading<span class="p">&lt;/</span><span class="nt">h2</span><span class="p">&gt;</span>
<span class="p">&lt;</span><span class="nt">h3</span><span class="p">&gt;</span>h3. Bootstrap heading<span class="p">&lt;/</span><span class="nt">h3</span><span class="p">&gt;</span>
<span class="p">&lt;</span><span class="nt">h4</span><span class="p">&gt;</span>h4. Bootstrap heading<span class="p">&lt;/</span><span class="nt">h4</span><span class="p">&gt;</span>
<span class="p">&lt;</span><span class="nt">h5</span><span class="p">&gt;</span>h5. Bootstrap heading<span class="p">&lt;/</span><span class="nt">h5</span><span class="p">&gt;</span>
<span class="p">&lt;</span><span class="nt">h6</span><span class="p">&gt;</span>h6. Bootstrap heading<span class="p">&lt;/</span><span class="nt">h6</span><span class="p">&gt;</span>
</code></pre>
        </div>
        <p>
          <code>.h1</code> through <code>.h6</code> classes are also available,
          for when you want to match the font styling of a heading but cannot
          use the associated HTML element.
        </p>
        <div class="bd-example">
          <p class="h1">h1. Bootstrap heading</p>
          <p class="h2">h2. Bootstrap heading</p>
          <p class="h3">h3. Bootstrap heading</p>
          <p class="h4">h4. Bootstrap heading</p>
          <p class="h5">h5. Bootstrap heading</p>
          <p class="h6">h6. Bootstrap heading</p>
        </div>
        <div class="bd-clipboard">
          <button
            type="button"
            class="btn-clipboard"
            title=""
            data-bs-original-title="Copy to clipboard"
          >
            Copy
          </button>
        </div>
        <div class="highlight">
          <pre
            class="chroma"
          ><code class="language-html" data-lang="html"><span class="p">&lt;</span><span class="nt">p</span> <span class="na">class</span><span class="o">=</span><span class="s">"h1"</span><span class="p">&gt;</span>h1. Bootstrap heading<span class="p">&lt;/</span><span class="nt">p</span><span class="p">&gt;</span>
<span class="p">&lt;</span><span class="nt">p</span> <span class="na">class</span><span class="o">=</span><span class="s">"h2"</span><span class="p">&gt;</span>h2. Bootstrap heading<span class="p">&lt;/</span><span class="nt">p</span><span class="p">&gt;</span>
<span class="p">&lt;</span><span class="nt">p</span> <span class="na">class</span><span class="o">=</span><span class="s">"h3"</span><span class="p">&gt;</span>h3. Bootstrap heading<span class="p">&lt;/</span><span class="nt">p</span><span class="p">&gt;</span>
<span class="p">&lt;</span><span class="nt">p</span> <span class="na">class</span><span class="o">=</span><span class="s">"h4"</span><span class="p">&gt;</span>h4. Bootstrap heading<span class="p">&lt;/</span><span class="nt">p</span><span class="p">&gt;</span>
<span class="p">&lt;</span><span class="nt">p</span> <span class="na">class</span><span class="o">=</span><span class="s">"h5"</span><span class="p">&gt;</span>h5. Bootstrap heading<span class="p">&lt;/</span><span class="nt">p</span><span class="p">&gt;</span>
<span class="p">&lt;</span><span class="nt">p</span> <span class="na">class</span><span class="o">=</span><span class="s">"h6"</span><span class="p">&gt;</span>h6. Bootstrap heading<span class="p">&lt;/</span><span class="nt">p</span><span class="p">&gt;</span></code></pre>
        </div>
        <h3 id="customizing-headings">
          Customizing headings<a
            class="anchorjs-link "
            aria-label="Anchor"
            data-anchorjs-icon="#"
            href="#customizing-headings"
            style="padding-left: 0.375em;"
          ></a>
        </h3>
        <p>
          Use the included utility classes to recreate the small secondary
          heading text from Bootstrap 3.
        </p>
        <div class="bd-example">
          <h3>
            Fancy display heading
            <small class="text-muted">With faded secondary text</small>
          </h3>
        </div>
        <div class="bd-clipboard">
          <button
            type="button"
            class="btn-clipboard"
            title=""
            data-bs-original-title="Copy to clipboard"
          >
            Copy
          </button>
        </div>
        <div class="highlight">
          <pre
            class="chroma"
          ><code class="language-html" data-lang="html"><span class="p">&lt;</span><span class="nt">h3</span><span class="p">&gt;</span>
  Fancy display heading
  <span class="p">&lt;</span><span class="nt">small</span> <span class="na">class</span><span class="o">=</span><span class="s">"text-muted"</span><span class="p">&gt;</span>With faded secondary text<span class="p">&lt;/</span><span class="nt">small</span><span class="p">&gt;</span>
<span class="p">&lt;/</span><span class="nt">h3</span><span class="p">&gt;</span></code></pre>
        </div>
        <h2 id="display-headings">
          Display headings<a
            class="anchorjs-link "
            aria-label="Anchor"
            data-anchorjs-icon="#"
            href="#display-headings"
            style="padding-left: 0.375em;"
          ></a>
        </h2>
        <p>
          Traditional heading elements are designed to work best in the meat of
          your page content. When you need a heading to stand out, consider
          using a <strong>display heading</strong>—a larger, slightly more
          opinionated heading style.
        </p>
        <div class="bd-example">
          <div class="display-1 pb-3 mb-3 border-bottom">Display 1</div>
          <div class="display-2 pb-3 mb-3 border-bottom">Display 2</div>
          <div class="display-3 pb-3 mb-3 border-bottom">Display 3</div>
          <div class="display-4 pb-3 mb-3 border-bottom">Display 4</div>
          <div class="display-5 pb-3 mb-3 border-bottom">Display 5</div>
          <div class="display-6">Display 6</div>
        </div>
        <div class="bd-clipboard">
          <button
            type="button"
            class="btn-clipboard"
            title=""
            data-bs-original-title="Copy to clipboard"
          >
            Copy
          </button>
        </div>
        <div class="highlight">
          <pre
            class="chroma"
          ><code class="language-html" data-lang="html"><span class="p">&lt;</span><span class="nt">h1</span> <span class="na">class</span><span class="o">=</span><span class="s">"display-1"</span><span class="p">&gt;</span>Display 1<span class="p">&lt;/</span><span class="nt">h1</span><span class="p">&gt;</span>
<span class="p">&lt;</span><span class="nt">h1</span> <span class="na">class</span><span class="o">=</span><span class="s">"display-2"</span><span class="p">&gt;</span>Display 2<span class="p">&lt;/</span><span class="nt">h1</span><span class="p">&gt;</span>
<span class="p">&lt;</span><span class="nt">h1</span> <span class="na">class</span><span class="o">=</span><span class="s">"display-3"</span><span class="p">&gt;</span>Display 3<span class="p">&lt;/</span><span class="nt">h1</span><span class="p">&gt;</span>
<span class="p">&lt;</span><span class="nt">h1</span> <span class="na">class</span><span class="o">=</span><span class="s">"display-4"</span><span class="p">&gt;</span>Display 4<span class="p">&lt;/</span><span class="nt">h1</span><span class="p">&gt;</span>
<span class="p">&lt;</span><span class="nt">h1</span> <span class="na">class</span><span class="o">=</span><span class="s">"display-5"</span><span class="p">&gt;</span>Display 5<span class="p">&lt;/</span><span class="nt">h1</span><span class="p">&gt;</span>
<span class="p">&lt;</span><span class="nt">h1</span> <span class="na">class</span><span class="o">=</span><span class="s">"display-6"</span><span class="p">&gt;</span>Display 6<span class="p">&lt;/</span><span class="nt">h1</span><span class="p">&gt;</span>
</code></pre>
        </div>
        <p>
          Display headings are configured via the
          <code>$display-font-sizes</code> Sass map and two variables,
          <code>$display-font-weight</code> and
          <code>$display-line-height</code>.
        </p>
        <div class="bd-clipboard">
          <button
            type="button"
            class="btn-clipboard"
            title=""
            data-bs-original-title="Copy to clipboard"
          >
            Copy
          </button>
        </div>
        <div class="highlight">
          <pre
            class="chroma"
          ><code class="language-scss" data-lang="scss"><span class="nv">$display-font-sizes</span><span class="o">:</span> <span class="p">(</span>
  <span class="na">1</span><span class="o">:</span> <span class="mi">5</span><span class="kt">rem</span><span class="o">,</span>
  <span class="na">2</span><span class="o">:</span> <span class="mi">4</span><span class="mf">.5</span><span class="kt">rem</span><span class="o">,</span>
  <span class="na">3</span><span class="o">:</span> <span class="mi">4</span><span class="kt">rem</span><span class="o">,</span>
  <span class="na">4</span><span class="o">:</span> <span class="mi">3</span><span class="mf">.5</span><span class="kt">rem</span><span class="o">,</span>
  <span class="na">5</span><span class="o">:</span> <span class="mi">3</span><span class="kt">rem</span><span class="o">,</span>
  <span class="na">6</span><span class="o">:</span> <span class="mi">2</span><span class="mf">.5</span><span class="kt">rem</span>
<span class="p">);</span>

<span class="nv">$display-font-weight</span><span class="o">:</span> <span class="mi">300</span><span class="p">;</span>
<span class="nv">$display-line-height</span><span class="o">:</span> <span class="nv">$headings-line-height</span><span class="p">;</span>
</code></pre>
        </div>
        <h2 id="lead">
          Lead<a
            class="anchorjs-link "
            aria-label="Anchor"
            data-anchorjs-icon="#"
            href="#lead"
            style="padding-left: 0.375em;"
          ></a>
        </h2>
        <p>Make a paragraph stand out by adding <code>.lead</code>.</p>
        <div class="bd-example">
          <p class="lead">
            This is a lead paragraph. It stands out from regular paragraphs.
          </p>
        </div>
        <div class="bd-clipboard">
          <button
            type="button"
            class="btn-clipboard"
            title=""
            data-bs-original-title="Copy to clipboard"
          >
            Copy
          </button>
        </div>
        <div class="highlight">
          <pre
            class="chroma"
          ><code class="language-html" data-lang="html"><span class="p">&lt;</span><span class="nt">p</span> <span class="na">class</span><span class="o">=</span><span class="s">"lead"</span><span class="p">&gt;</span>
  This is a lead paragraph. It stands out from regular paragraphs.
<span class="p">&lt;/</span><span class="nt">p</span><span class="p">&gt;</span></code></pre>
        </div>
        <h2 id="inline-text-elements">
          Inline text elements<a
            class="anchorjs-link "
            aria-label="Anchor"
            data-anchorjs-icon="#"
            href="#inline-text-elements"
            style="padding-left: 0.375em;"
          ></a>
        </h2>
        <p>Styling for common inline HTML5 elements.</p>
        <div class="bd-example">
          <p>You can use the mark tag to <mark>highlight</mark> text.</p>
          <p>
            <del>This line of text is meant to be treated as deleted text.</del>
          </p>
          <p>
            <s
              >This line of text is meant to be treated as no longer
              accurate.</s
            >
          </p>
          <p>
            <ins
              >This line of text is meant to be treated as an addition to the
              document.</ins
            >
          </p>
          <p><u>This line of text will render as underlined.</u></p>
          <p>
            <small
              >This line of text is meant to be treated as fine print.</small
            >
          </p>
          <p><strong>This line rendered as bold text.</strong></p>
          <p><em>This line rendered as italicized text.</em></p>
        </div>
        <div class="bd-clipboard">
          <button
            type="button"
            class="btn-clipboard"
            title=""
            data-bs-original-title="Copy to clipboard"
          >
            Copy
          </button>
        </div>
        <div class="highlight">
          <pre
            class="chroma"
          ><code class="language-html" data-lang="html"><span class="p">&lt;</span><span class="nt">p</span><span class="p">&gt;</span>You can use the mark tag to <span class="p">&lt;</span><span class="nt">mark</span><span class="p">&gt;</span>highlight<span class="p">&lt;/</span><span class="nt">mark</span><span class="p">&gt;</span> text.<span class="p">&lt;/</span><span class="nt">p</span><span class="p">&gt;</span>
<span class="p">&lt;</span><span class="nt">p</span><span class="p">&gt;&lt;</span><span class="nt">del</span><span class="p">&gt;</span>This line of text is meant to be treated as deleted text.<span class="p">&lt;/</span><span class="nt">del</span><span class="p">&gt;&lt;/</span><span class="nt">p</span><span class="p">&gt;</span>
<span class="p">&lt;</span><span class="nt">p</span><span class="p">&gt;&lt;</span><span class="nt">s</span><span class="p">&gt;</span>This line of text is meant to be treated as no longer accurate.<span class="p">&lt;/</span><span class="nt">s</span><span class="p">&gt;&lt;/</span><span class="nt">p</span><span class="p">&gt;</span>
<span class="p">&lt;</span><span class="nt">p</span><span class="p">&gt;&lt;</span><span class="nt">ins</span><span class="p">&gt;</span>This line of text is meant to be treated as an addition to the document.<span class="p">&lt;/</span><span class="nt">ins</span><span class="p">&gt;&lt;/</span><span class="nt">p</span><span class="p">&gt;</span>
<span class="p">&lt;</span><span class="nt">p</span><span class="p">&gt;&lt;</span><span class="nt">u</span><span class="p">&gt;</span>This line of text will render as underlined.<span class="p">&lt;/</span><span class="nt">u</span><span class="p">&gt;&lt;/</span><span class="nt">p</span><span class="p">&gt;</span>
<span class="p">&lt;</span><span class="nt">p</span><span class="p">&gt;&lt;</span><span class="nt">small</span><span class="p">&gt;</span>This line of text is meant to be treated as fine print.<span class="p">&lt;/</span><span class="nt">small</span><span class="p">&gt;&lt;/</span><span class="nt">p</span><span class="p">&gt;</span>
<span class="p">&lt;</span><span class="nt">p</span><span class="p">&gt;&lt;</span><span class="nt">strong</span><span class="p">&gt;</span>This line rendered as bold text.<span class="p">&lt;/</span><span class="nt">strong</span><span class="p">&gt;&lt;/</span><span class="nt">p</span><span class="p">&gt;</span>
<span class="p">&lt;</span><span class="nt">p</span><span class="p">&gt;&lt;</span><span class="nt">em</span><span class="p">&gt;</span>This line rendered as italicized text.<span class="p">&lt;/</span><span class="nt">em</span><span class="p">&gt;&lt;/</span><span class="nt">p</span><span class="p">&gt;</span></code></pre>
        </div>
        <p>Beware that those tags should be used for semantic purpose:</p>
        <ul>
          <li>
            <code>&lt;mark&gt;</code> represents text which is marked or
            highlighted for reference or notation purposes.
          </li>
          <li>
            <code>&lt;small&gt;</code> represents side-comments and small print,
            like copyright and legal text.
          </li>
          <li>
            <code>&lt;s&gt;</code> represents element that are no longer
            relevant or no longer accurate.
          </li>
          <li>
            <code>&lt;u&gt;</code> represents a span of inline text which should
            be rendered in a way that indicates that it has a non-textual
            annotation.
          </li>
        </ul>
        <p>
          If you want to style your text, you should use the following classes
          instead:
        </p>
        <ul>
          <li>
            <code>.mark</code> will apply the same styles as
            <code>&lt;mark&gt;</code>.
          </li>
          <li>
            <code>.small</code> will apply the same styles as
            <code>&lt;small&gt;</code>.
          </li>
          <li>
            <code>.text-decoration-underline</code> will apply the same styles
            as <code>&lt;u&gt;</code>.
          </li>
          <li>
            <code>.text-decoration-line-through</code> will apply the same
            styles as <code>&lt;s&gt;</code>.
          </li>
        </ul>
        <p>
          While not shown above, feel free to use <code>&lt;b&gt;</code> and
          <code>&lt;i&gt;</code> in HTML5. <code>&lt;b&gt;</code> is meant to
          highlight words or phrases without conveying additional importance,
          while <code>&lt;i&gt;</code> is mostly for voice, technical terms,
          etc.
        </p>
        <h2 id="text-utilities">
          Text utilities<a
            class="anchorjs-link "
            aria-label="Anchor"
            data-anchorjs-icon="#"
            href="#text-utilities"
            style="padding-left: 0.375em;"
          ></a>
        </h2>
        <p>
          Change text alignment, transform, style, weight, line-height,
          decoration and color with our
          <a href="/docs/5.0/utilities/text/">text utilities</a> and
          <a href="/docs/5.0/utilities/colors/">color utilities</a>.
        </p>
        <h2 id="abbreviations">
          Abbreviations<a
            class="anchorjs-link "
            aria-label="Anchor"
            data-anchorjs-icon="#"
            href="#abbreviations"
            style="padding-left: 0.375em;"
          ></a>
        </h2>
        <p>
          Stylized implementation of HTML’s <code>&lt;abbr&gt;</code> element
          for abbreviations and acronyms to show the expanded version on hover.
          Abbreviations have a default underline and gain a help cursor to
          provide additional context on hover and to users of assistive
          technologies.
        </p>
        <p>
          Add <code>.initialism</code> to an abbreviation for a slightly smaller
          font-size.
        </p>
        <div class="bd-example">
          <p><abbr title="attribute">attr</abbr></p>
          <p>
            <abbr title="HyperText Markup Language" class="initialism"
              >HTML</abbr
            >
          </p>
        </div>
        <div class="bd-clipboard">
          <button
            type="button"
            class="btn-clipboard"
            title=""
            data-bs-original-title="Copy to clipboard"
          >
            Copy
          </button>
        </div>
        <div class="highlight">
          <pre
            class="chroma"
          ><code class="language-html" data-lang="html"><span class="p">&lt;</span><span class="nt">p</span><span class="p">&gt;&lt;</span><span class="nt">abbr</span> <span class="na">title</span><span class="o">=</span><span class="s">"attribute"</span><span class="p">&gt;</span>attr<span class="p">&lt;/</span><span class="nt">abbr</span><span class="p">&gt;&lt;/</span><span class="nt">p</span><span class="p">&gt;</span>
<span class="p">&lt;</span><span class="nt">p</span><span class="p">&gt;&lt;</span><span class="nt">abbr</span> <span class="na">title</span><span class="o">=</span><span class="s">"HyperText Markup Language"</span> <span class="na">class</span><span class="o">=</span><span class="s">"initialism"</span><span class="p">&gt;</span>HTML<span class="p">&lt;/</span><span class="nt">abbr</span><span class="p">&gt;&lt;/</span><span class="nt">p</span><span class="p">&gt;</span></code></pre>
        </div>
        <h2 id="blockquotes">
          Blockquotes<a
            class="anchorjs-link "
            aria-label="Anchor"
            data-anchorjs-icon="#"
            href="#blockquotes"
            style="padding-left: 0.375em;"
          ></a>
        </h2>
        <p>
          For quoting blocks of content from another source within your
          document. Wrap
          <code>&lt;blockquote class="blockquote"&gt;</code> around any
          <abbr title="HyperText Markup Language">HTML</abbr> as the quote.
        </p>
        <div class="bd-example">
          <blockquote class="blockquote">
            <p>A well-known quote, contained in a blockquote element.</p>
          </blockquote>
        </div>
        <div class="bd-clipboard">
          <button
            type="button"
            class="btn-clipboard"
            title=""
            data-bs-original-title="Copy to clipboard"
          >
            Copy
          </button>
        </div>
        <div class="highlight">
          <pre
            class="chroma"
          ><code class="language-html" data-lang="html"><span class="p">&lt;</span><span class="nt">blockquote</span> <span class="na">class</span><span class="o">=</span><span class="s">"blockquote"</span><span class="p">&gt;</span>
  <span class="p">&lt;</span><span class="nt">p</span><span class="p">&gt;</span>A well-known quote, contained in a blockquote element.<span class="p">&lt;/</span><span class="nt">p</span><span class="p">&gt;</span>
<span class="p">&lt;/</span><span class="nt">blockquote</span><span class="p">&gt;</span></code></pre>
        </div>
        <h3 id="naming-a-source">
          Naming a source<a
            class="anchorjs-link "
            aria-label="Anchor"
            data-anchorjs-icon="#"
            href="#naming-a-source"
            style="padding-left: 0.375em;"
          ></a>
        </h3>
        <p>
          The HTML spec requires that blockquote attribution be placed outside
          the
          <code>&lt;blockquote&gt;</code>. When providing attribution, wrap your
          <code>&lt;blockquote&gt;</code> in a <code>&lt;figure&gt;</code> and
          use a <code>&lt;figcaption&gt;</code> or a block level element (e.g.,
          <code>&lt;p&gt;</code>) with the
          <code>.blockquote-footer</code> class. Be sure to wrap the name of the
          source work in <code>&lt;cite&gt;</code> as well.
        </p>
        <div class="bd-example">
          <figure>
            <blockquote class="blockquote">
              <p>A well-known quote, contained in a blockquote element.</p>
            </blockquote>
            <figcaption class="blockquote-footer">
              Someone famous in <cite title="Source Title">Source Title</cite>
            </figcaption>
          </figure>
        </div>
        <div class="bd-clipboard">
          <button
            type="button"
            class="btn-clipboard"
            title=""
            data-bs-original-title="Copy to clipboard"
          >
            Copy
          </button>
        </div>
        <div class="highlight">
          <pre
            class="chroma"
          ><code class="language-html" data-lang="html"><span class="p">&lt;</span><span class="nt">figure</span><span class="p">&gt;</span>
  <span class="p">&lt;</span><span class="nt">blockquote</span> <span class="na">class</span><span class="o">=</span><span class="s">"blockquote"</span><span class="p">&gt;</span>
    <span class="p">&lt;</span><span class="nt">p</span><span class="p">&gt;</span>A well-known quote, contained in a blockquote element.<span class="p">&lt;/</span><span class="nt">p</span><span class="p">&gt;</span>
  <span class="p">&lt;/</span><span class="nt">blockquote</span><span class="p">&gt;</span>
  <span class="p">&lt;</span><span class="nt">figcaption</span> <span class="na">class</span><span class="o">=</span><span class="s">"blockquote-footer"</span><span class="p">&gt;</span>
    Someone famous in <span class="p">&lt;</span><span class="nt">cite</span> <span class="na">title</span><span class="o">=</span><span class="s">"Source Title"</span><span class="p">&gt;</span>Source Title<span class="p">&lt;/</span><span class="nt">cite</span><span class="p">&gt;</span>
  <span class="p">&lt;/</span><span class="nt">figcaption</span><span class="p">&gt;</span>
<span class="p">&lt;/</span><span class="nt">figure</span><span class="p">&gt;</span></code></pre>
        </div>
        <h3 id="alignment">
          Alignment<a
            class="anchorjs-link "
            aria-label="Anchor"
            data-anchorjs-icon="#"
            href="#alignment"
            style="padding-left: 0.375em;"
          ></a>
        </h3>
        <p>
          Use text utilities as needed to change the alignment of your
          blockquote.
        </p>
        <div class="bd-example">
          <figure class="text-center">
            <blockquote class="blockquote">
              <p>A well-known quote, contained in a blockquote element.</p>
            </blockquote>
            <figcaption class="blockquote-footer">
              Someone famous in <cite title="Source Title">Source Title</cite>
            </figcaption>
          </figure>
        </div>
        <div class="bd-clipboard">
          <button
            type="button"
            class="btn-clipboard"
            title=""
            data-bs-original-title="Copy to clipboard"
          >
            Copy
          </button>
        </div>
        <div class="highlight">
          <pre
            class="chroma"
          ><code class="language-html" data-lang="html"><span class="p">&lt;</span><span class="nt">figure</span> <span class="na">class</span><span class="o">=</span><span class="s">"text-center"</span><span class="p">&gt;</span>
  <span class="p">&lt;</span><span class="nt">blockquote</span> <span class="na">class</span><span class="o">=</span><span class="s">"blockquote"</span><span class="p">&gt;</span>
    <span class="p">&lt;</span><span class="nt">p</span><span class="p">&gt;</span>A well-known quote, contained in a blockquote element.<span class="p">&lt;/</span><span class="nt">p</span><span class="p">&gt;</span>
  <span class="p">&lt;/</span><span class="nt">blockquote</span><span class="p">&gt;</span>
  <span class="p">&lt;</span><span class="nt">figcaption</span> <span class="na">class</span><span class="o">=</span><span class="s">"blockquote-footer"</span><span class="p">&gt;</span>
    Someone famous in <span class="p">&lt;</span><span class="nt">cite</span> <span class="na">title</span><span class="o">=</span><span class="s">"Source Title"</span><span class="p">&gt;</span>Source Title<span class="p">&lt;/</span><span class="nt">cite</span><span class="p">&gt;</span>
  <span class="p">&lt;/</span><span class="nt">figcaption</span><span class="p">&gt;</span>
<span class="p">&lt;/</span><span class="nt">figure</span><span class="p">&gt;</span></code></pre>
        </div>
        <div class="bd-example">
          <figure class="text-end">
            <blockquote class="blockquote">
              <p>A well-known quote, contained in a blockquote element.</p>
            </blockquote>
            <figcaption class="blockquote-footer">
              Someone famous in <cite title="Source Title">Source Title</cite>
            </figcaption>
          </figure>
        </div>
        <div class="bd-clipboard">
          <button
            type="button"
            class="btn-clipboard"
            title=""
            data-bs-original-title="Copy to clipboard"
          >
            Copy
          </button>
        </div>
        <div class="highlight">
          <pre
            class="chroma"
          ><code class="language-html" data-lang="html"><span class="p">&lt;</span><span class="nt">figure</span> <span class="na">class</span><span class="o">=</span><span class="s">"text-end"</span><span class="p">&gt;</span>
  <span class="p">&lt;</span><span class="nt">blockquote</span> <span class="na">class</span><span class="o">=</span><span class="s">"blockquote"</span><span class="p">&gt;</span>
    <span class="p">&lt;</span><span class="nt">p</span><span class="p">&gt;</span>A well-known quote, contained in a blockquote element.<span class="p">&lt;/</span><span class="nt">p</span><span class="p">&gt;</span>
  <span class="p">&lt;/</span><span class="nt">blockquote</span><span class="p">&gt;</span>
  <span class="p">&lt;</span><span class="nt">figcaption</span> <span class="na">class</span><span class="o">=</span><span class="s">"blockquote-footer"</span><span class="p">&gt;</span>
    Someone famous in <span class="p">&lt;</span><span class="nt">cite</span> <span class="na">title</span><span class="o">=</span><span class="s">"Source Title"</span><span class="p">&gt;</span>Source Title<span class="p">&lt;/</span><span class="nt">cite</span><span class="p">&gt;</span>
  <span class="p">&lt;/</span><span class="nt">figcaption</span><span class="p">&gt;</span>
<span class="p">&lt;/</span><span class="nt">figure</span><span class="p">&gt;</span></code></pre>
        </div>
        <h2 id="lists">
          Lists<a
            class="anchorjs-link "
            aria-label="Anchor"
            data-anchorjs-icon="#"
            href="#lists"
            style="padding-left: 0.375em;"
          ></a>
        </h2>
        <h3 id="unstyled">
          Unstyled<a
            class="anchorjs-link "
            aria-label="Anchor"
            data-anchorjs-icon="#"
            href="#unstyled"
            style="padding-left: 0.375em;"
          ></a>
        </h3>
        <p>
          Remove the default <code>list-style</code> and left margin on list
          items (immediate children only).
          <strong>This only applies to immediate children list items</strong>,
          meaning you will need to add the class for any nested lists as well.
        </p>
        <div class="bd-example">
          <ul class="list-unstyled">
            <li>This is a list.</li>
            <li>It appears completely unstyled.</li>
            <li>Structurally, it's still a list.</li>
            <li>
              However, this style only applies to immediate child elements.
            </li>
            <li>
              Nested lists:
              <ul>
                <li>are unaffected by this style</li>
                <li>will still show a bullet</li>
                <li>and have appropriate left margin</li>
              </ul>
            </li>
            <li>This may still come in handy in some situations.</li>
          </ul>
        </div>
        <div class="bd-clipboard">
          <button
            type="button"
            class="btn-clipboard"
            title=""
            data-bs-original-title="Copy to clipboard"
          >
            Copy
          </button>
        </div>
        <div class="highlight">
          <pre
            class="chroma"
          ><code class="language-html" data-lang="html"><span class="p">&lt;</span><span class="nt">ul</span> <span class="na">class</span><span class="o">=</span><span class="s">"list-unstyled"</span><span class="p">&gt;</span>
  <span class="p">&lt;</span><span class="nt">li</span><span class="p">&gt;</span>This is a list.<span class="p">&lt;/</span><span class="nt">li</span><span class="p">&gt;</span>
  <span class="p">&lt;</span><span class="nt">li</span><span class="p">&gt;</span>It appears completely unstyled.<span class="p">&lt;/</span><span class="nt">li</span><span class="p">&gt;</span>
  <span class="p">&lt;</span><span class="nt">li</span><span class="p">&gt;</span>Structurally, it's still a list.<span class="p">&lt;/</span><span class="nt">li</span><span class="p">&gt;</span>
  <span class="p">&lt;</span><span class="nt">li</span><span class="p">&gt;</span>However, this style only applies to immediate child elements.<span class="p">&lt;/</span><span class="nt">li</span><span class="p">&gt;</span>
  <span class="p">&lt;</span><span class="nt">li</span><span class="p">&gt;</span>Nested lists:
    <span class="p">&lt;</span><span class="nt">ul</span><span class="p">&gt;</span>
      <span class="p">&lt;</span><span class="nt">li</span><span class="p">&gt;</span>are unaffected by this style<span class="p">&lt;/</span><span class="nt">li</span><span class="p">&gt;</span>
      <span class="p">&lt;</span><span class="nt">li</span><span class="p">&gt;</span>will still show a bullet<span class="p">&lt;/</span><span class="nt">li</span><span class="p">&gt;</span>
      <span class="p">&lt;</span><span class="nt">li</span><span class="p">&gt;</span>and have appropriate left margin<span class="p">&lt;/</span><span class="nt">li</span><span class="p">&gt;</span>
    <span class="p">&lt;/</span><span class="nt">ul</span><span class="p">&gt;</span>
  <span class="p">&lt;/</span><span class="nt">li</span><span class="p">&gt;</span>
  <span class="p">&lt;</span><span class="nt">li</span><span class="p">&gt;</span>This may still come in handy in some situations.<span class="p">&lt;/</span><span class="nt">li</span><span class="p">&gt;</span>
<span class="p">&lt;/</span><span class="nt">ul</span><span class="p">&gt;</span></code></pre>
        </div>
        <h3 id="inline">
          Inline<a
            class="anchorjs-link "
            aria-label="Anchor"
            data-anchorjs-icon="#"
            href="#inline"
            style="padding-left: 0.375em;"
          ></a>
        </h3>
        <p>
          Remove a list’s bullets and apply some light <code>margin</code> with
          a combination of two classes, <code>.list-inline</code> and
          <code>.list-inline-item</code>.
        </p>
        <div class="bd-example">
          <ul class="list-inline">
            <li class="list-inline-item">This is a list item.</li>
            <li class="list-inline-item">And another one.</li>
            <li class="list-inline-item">But they're displayed inline.</li>
          </ul>
        </div>
        <div class="bd-clipboard">
          <button
            type="button"
            class="btn-clipboard"
            title=""
            data-bs-original-title="Copy to clipboard"
          >
            Copy
          </button>
        </div>
        <div class="highlight">
          <pre
            class="chroma"
          ><code class="language-html" data-lang="html"><span class="p">&lt;</span><span class="nt">ul</span> <span class="na">class</span><span class="o">=</span><span class="s">"list-inline"</span><span class="p">&gt;</span>
  <span class="p">&lt;</span><span class="nt">li</span> <span class="na">class</span><span class="o">=</span><span class="s">"list-inline-item"</span><span class="p">&gt;</span>This is a list item.<span class="p">&lt;/</span><span class="nt">li</span><span class="p">&gt;</span>
  <span class="p">&lt;</span><span class="nt">li</span> <span class="na">class</span><span class="o">=</span><span class="s">"list-inline-item"</span><span class="p">&gt;</span>And another one.<span class="p">&lt;/</span><span class="nt">li</span><span class="p">&gt;</span>
  <span class="p">&lt;</span><span class="nt">li</span> <span class="na">class</span><span class="o">=</span><span class="s">"list-inline-item"</span><span class="p">&gt;</span>But they're displayed inline.<span class="p">&lt;/</span><span class="nt">li</span><span class="p">&gt;</span>
<span class="p">&lt;/</span><span class="nt">ul</span><span class="p">&gt;</span></code></pre>
        </div>
        <h3 id="description-list-alignment">
          Description list alignment<a
            class="anchorjs-link "
            aria-label="Anchor"
            data-anchorjs-icon="#"
            href="#description-list-alignment"
            style="padding-left: 0.375em;"
          ></a>
        </h3>
        <p>
          Align terms and descriptions horizontally by using our grid system’s
          predefined classes (or semantic mixins). For longer terms, you can
          optionally add a <code>.text-truncate</code> class to truncate the
          text with an ellipsis.
        </p>
        <div class="bd-example">
          <dl class="row">
            <dt class="col-sm-3">Description lists</dt>
            <dd class="col-sm-9">
              A description list is perfect for defining terms.
            </dd>

            <dt class="col-sm-3">Term</dt>
            <dd class="col-sm-9">
              <p>Definition for the term.</p>
              <p>And some more placeholder definition text.</p>
            </dd>

            <dt class="col-sm-3">Another term</dt>
            <dd class="col-sm-9">
              This definition is short, so no extra paragraphs or anything.
            </dd>

            <dt class="col-sm-3 text-truncate">Truncated term is truncated</dt>
            <dd class="col-sm-9">
              This can be useful when space is tight. Adds an ellipsis at the
              end.
            </dd>

            <dt class="col-sm-3">Nesting</dt>
            <dd class="col-sm-9">
              <dl class="row">
                <dt class="col-sm-4">Nested definition list</dt>
                <dd class="col-sm-8">
                  I heard you like definition lists. Let me put a definition
                  list inside your definition list.
                </dd>
              </dl>
            </dd>
          </dl>
        </div>
        <div class="bd-clipboard">
          <button
            type="button"
            class="btn-clipboard"
            title=""
            data-bs-original-title="Copy to clipboard"
          >
            Copy
          </button>
        </div>
        <div class="highlight">
          <pre
            class="chroma"
          ><code class="language-html" data-lang="html"><span class="p">&lt;</span><span class="nt">dl</span> <span class="na">class</span><span class="o">=</span><span class="s">"row"</span><span class="p">&gt;</span>
  <span class="p">&lt;</span><span class="nt">dt</span> <span class="na">class</span><span class="o">=</span><span class="s">"col-sm-3"</span><span class="p">&gt;</span>Description lists<span class="p">&lt;/</span><span class="nt">dt</span><span class="p">&gt;</span>
  <span class="p">&lt;</span><span class="nt">dd</span> <span class="na">class</span><span class="o">=</span><span class="s">"col-sm-9"</span><span class="p">&gt;</span>A description list is perfect for defining terms.<span class="p">&lt;/</span><span class="nt">dd</span><span class="p">&gt;</span>

  <span class="p">&lt;</span><span class="nt">dt</span> <span class="na">class</span><span class="o">=</span><span class="s">"col-sm-3"</span><span class="p">&gt;</span>Term<span class="p">&lt;/</span><span class="nt">dt</span><span class="p">&gt;</span>
  <span class="p">&lt;</span><span class="nt">dd</span> <span class="na">class</span><span class="o">=</span><span class="s">"col-sm-9"</span><span class="p">&gt;</span>
    <span class="p">&lt;</span><span class="nt">p</span><span class="p">&gt;</span>Definition for the term.<span class="p">&lt;/</span><span class="nt">p</span><span class="p">&gt;</span>
    <span class="p">&lt;</span><span class="nt">p</span><span class="p">&gt;</span>And some more placeholder definition text.<span class="p">&lt;/</span><span class="nt">p</span><span class="p">&gt;</span>
  <span class="p">&lt;/</span><span class="nt">dd</span><span class="p">&gt;</span>

  <span class="p">&lt;</span><span class="nt">dt</span> <span class="na">class</span><span class="o">=</span><span class="s">"col-sm-3"</span><span class="p">&gt;</span>Another term<span class="p">&lt;/</span><span class="nt">dt</span><span class="p">&gt;</span>
  <span class="p">&lt;</span><span class="nt">dd</span> <span class="na">class</span><span class="o">=</span><span class="s">"col-sm-9"</span><span class="p">&gt;</span>This definition is short, so no extra paragraphs or anything.<span class="p">&lt;/</span><span class="nt">dd</span><span class="p">&gt;</span>

  <span class="p">&lt;</span><span class="nt">dt</span> <span class="na">class</span><span class="o">=</span><span class="s">"col-sm-3 text-truncate"</span><span class="p">&gt;</span>Truncated term is truncated<span class="p">&lt;/</span><span class="nt">dt</span><span class="p">&gt;</span>
  <span class="p">&lt;</span><span class="nt">dd</span> <span class="na">class</span><span class="o">=</span><span class="s">"col-sm-9"</span><span class="p">&gt;</span>This can be useful when space is tight. Adds an ellipsis at the end.<span class="p">&lt;/</span><span class="nt">dd</span><span class="p">&gt;</span>

  <span class="p">&lt;</span><span class="nt">dt</span> <span class="na">class</span><span class="o">=</span><span class="s">"col-sm-3"</span><span class="p">&gt;</span>Nesting<span class="p">&lt;/</span><span class="nt">dt</span><span class="p">&gt;</span>
  <span class="p">&lt;</span><span class="nt">dd</span> <span class="na">class</span><span class="o">=</span><span class="s">"col-sm-9"</span><span class="p">&gt;</span>
    <span class="p">&lt;</span><span class="nt">dl</span> <span class="na">class</span><span class="o">=</span><span class="s">"row"</span><span class="p">&gt;</span>
      <span class="p">&lt;</span><span class="nt">dt</span> <span class="na">class</span><span class="o">=</span><span class="s">"col-sm-4"</span><span class="p">&gt;</span>Nested definition list<span class="p">&lt;/</span><span class="nt">dt</span><span class="p">&gt;</span>
      <span class="p">&lt;</span><span class="nt">dd</span> <span class="na">class</span><span class="o">=</span><span class="s">"col-sm-8"</span><span class="p">&gt;</span>I heard you like definition lists. Let me put a definition list inside your definition list.<span class="p">&lt;/</span><span class="nt">dd</span><span class="p">&gt;</span>
    <span class="p">&lt;/</span><span class="nt">dl</span><span class="p">&gt;</span>
  <span class="p">&lt;/</span><span class="nt">dd</span><span class="p">&gt;</span>
<span class="p">&lt;/</span><span class="nt">dl</span><span class="p">&gt;</span></code></pre>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "Typography",
  route: {
    path: "/typography", // this is the url path
    name: "Typography ",
  },
};
</script>

<style lang="scss">
/*! CSS Used from: https://getbootstrap.com/docs/5.0/dist/css/bootstrap.min.css */
*,
::after,
::before {
  box-sizing: border-box;
}
code,
pre {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
  direction: ltr;
  unicode-bidi: bidi-override;
}
pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}
code {
  font-size: 0.875em;
  color: #d63384;
  word-wrap: break-word;
}
::-moz-focus-inner {
  padding: 0;
  border-style: none;
}
/*! CSS Used from: https://getbootstrap.com/docs/5.0/assets/css/docs.css */
.highlight {
  padding: 1rem;
  margin-bottom: 1rem;
  background-color: #f8f9fa;
}
@media (min-width: 576px) {
  .highlight {
    padding: 1rem 1.5rem;
  }
}
.highlight pre {
  padding: 0;
  margin-top: 0.65rem;
  margin-bottom: 0.65rem;
  white-space: pre;
  background-color: transparent;
  border: 0;
}
.highlight pre code {
  font-size: inherit;
  color: #212529;
  word-wrap: normal;
}
.bd-content .highlight {
  margin-right: -0.75rem;
  margin-left: -0.75rem;
}
@media (min-width: 576px) {
  .bd-content .highlight {
    margin-right: 0;
    margin-left: 0;
  }
}
.bd-clipboard + .highlight {
  margin-top: 0;
}
.chroma .nt {
  color: #2f6f9f;
}
// add styles here supports scss

/*! CSS Used from: https://getbootstrap.com/docs/5.0/dist/css/bootstrap.min.css */
*,
::after,
::before {
  box-sizing: border-box;
}
button {
  border-radius: 0;
}
button:focus:not(:focus-visible) {
  outline: 0;
}
button {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}
button {
  text-transform: none;
}
[type="button"],
button {
  -webkit-appearance: button;
}
::-moz-focus-inner {
  padding: 0;
  border-style: none;
}
/*! CSS Used from: https://getbootstrap.com/docs/5.0/assets/css/docs.css */
.bd-clipboard {
  position: relative;
  display: none;
  float: right;
}
@media (min-width: 768px) {
  .bd-clipboard {
    display: block;
  }
}
.btn-clipboard {
  position: absolute;
  top: 0.65rem;
  right: 0.65rem;
  z-index: 10;
  display: block;
  padding: 0.25rem 0.5rem;
  font-size: 0.65em;
  color: #0d6efd;
  background-color: #fff;
  border: 1px solid;
  border-radius: 0.25rem;
}
.btn-clipboard:hover,
.btn-clipboard:focus {
  color: #fff;
  background-color: #0d6efd;
}

// styles for sidebar
/*! CSS Used from: https://getbootstrap.com/docs/5.0/dist/css/bootstrap.min.css */
*,::after,::before{box-sizing:border-box;}
.h6{margin-top:0;margin-bottom:.5rem;font-weight:500;line-height:1.2;}
.h6{font-size:1rem;}
ul{padding-left:2rem;}
ul{margin-top:0;margin-bottom:1rem;}
ul ul{margin-bottom:0;}
strong{font-weight:bolder;}
a{color:#0d6efd;text-decoration:underline;}
a:hover{color:#0a58ca;}
::-moz-focus-inner{padding:0;border-style:none;}
.d-block{display:block!important;}
.border-bottom{border-bottom:1px solid #dee2e6!important;}
.my-2{margin-top:.5rem!important;margin-bottom:.5rem!important;}
.mt-4{margin-top:1.5rem!important;}
.mb-5{margin-bottom:3rem!important;}
.pb-2{padding-bottom:.5rem!important;}
.text-muted{color:#6c757d!important;}
@media (min-width:768px){
.my-md-0{margin-top:0!important;margin-bottom:0!important;}
}
@media (min-width:992px){
.mb-lg-5{margin-bottom:3rem!important;}
}
@media (min-width:1200px){
.ps-xl-3{padding-left:1rem!important;}
}
/*! CSS Used from: https://getbootstrap.com/docs/5.0/assets/css/docs.css */
.bd-toc{grid-area:toc;}
@media (min-width: 992px){
.bd-toc{position:-webkit-sticky;position:sticky;top:5rem;right:0;z-index:2;height:calc(100vh - 7rem);overflow-y:auto;}
}
.bd-toc nav{font-size:.875rem;}
.bd-toc nav ul{padding-left:0;list-style:none;}
.bd-toc nav ul ul{padding-left:1rem;margin-top:.25rem;}
.bd-toc nav li{margin-bottom:.25rem;}
.bd-toc nav a{color:inherit;}

</style>
